import React from 'react';
import {connect} from 'react-redux';
import {change, Field} from "redux-form";

import ExpandSection from "../../Generic/expandSection";
import {toggleSectionOpened} from "../AccountActions";
import {ACCOUNT_SECTIONS} from "./sectionNames";
import {FormCheckBoxField, HiddenField} from "../FormField";
import {AccessRights} from "../../../schemas/accessRightsModel";
import {setDocuSignPopupState, setFingerSignaturePopupState} from "../../../actions/A_Popups";
import {store} from "../../../main";

class DocusignAndFingerSignature extends React.Component {

  componentDidMount() {
    if (this.props.formValues && this.props.formValues.docuSignAuth) {
      const obj = JSON.parse(this.props.formValues.docuSignAuth);
      // console.log("obj", obj);
      this.props.setDocuSignPopupState({
        ds_sandBoxUserId: obj.sandBoxClientId,
        ds_sandBoxAuthToken: obj.accessToken,
        ds_prodClientId: obj.clientId,
        ds_prodUserId: obj.impersonateUserGuid,
        ds_prodPrivateKey: obj.privateKey,
        ds_isProduction: !obj.isSandBox,
        ds_checkOutContractId: (obj.docuSignTemplates && obj.docuSignTemplates.checkOutContract.id) || 0,
        docuSignObj: {...obj}
      });
      store.dispatch(change('newEntity', 'enableDocuSign', obj.isEnabled));
    }
  }

  updateCheckBoxField = (input) => {
    store.dispatch(change('newEntity', input.name, !input.value))
  };

  render() {
    const {AR, formValues} = this.props;
    const {isLicensedFabricator} = this.props.accountPageInfo;

    const isSiteAdmin = AR.isSiteAdmin(false);
    const docuSignButtonDisabled = !formValues.enableDocuSign || isLicensedFabricator;
    const fingerButtonDisabled = !formValues.enableFingerSignature || isLicensedFabricator;
    return (
      <ExpandSection opened={this.props.sectionsOpened.includes(ACCOUNT_SECTIONS.docusign_and_finger_signature)}
                     onClick={() => this.props.toggleSectionOpened(ACCOUNT_SECTIONS.docusign_and_finger_signature)}
                     title="Document Signing (Docusign & Finger Signature)">
        <div className="acc-container">
          <div className="acc-container__row">
            {isSiteAdmin || formValues.enableDocuSign ? (
              <div className="acc-block3">
                <Field name="docuSignAuth" component={HiddenField}/>
                <Field name="enableDocuSign" component={FormCheckBoxField} onChecked={this.updateCheckBoxField}
                       labelEnabled="Enable DocuSign" labelDisabled="Enable DocuSign" doubleMargin={true}
                       disabled={!isSiteAdmin || formValues.enableFingerSignature || isLicensedFabricator}/>
                <button className={"ui-button2 ui-button2--blue" + (docuSignButtonDisabled ? " ui-button2--disabled" : "")}
                        type="button" disabled={docuSignButtonDisabled}
                        onClick={() => this.props.setDocuSignPopupState({
                          showPopup: true
                        })}>
                  Set DocuSign parameters
                </button>
              </div>
            ) : null}
            {formValues.enableDocuSign && !isSiteAdmin ? null : (
              <div className="acc-block3 flex">
                <div className="acc-block">
                  <Field name="enableFingerSignature" component={FormCheckBoxField} onChecked={this.updateCheckBoxField}
                         labelEnabled="Enable Finger Signature" labelDisabled="Enable Finger Signature"
                         disabled={formValues.enableDocuSign || isLicensedFabricator} doubleMargin={true}
                         enableFingerSignature
                  />
                  <Field name="fingerSignatureTermsAcceptedAt" component={HiddenField}/>
                  <Field name="fingerSignatureMasterDocumentFullUrl" component={HiddenField}/>
                  <button className={"ui-button2 ui-button2--blue" + (fingerButtonDisabled ? " ui-button2--disabled" : "")}
                          type="button" disabled={fingerButtonDisabled}
                          onClick={() => this.props.setFingerSignaturePopupState({
                            showPopup: true,
                          })}>
                    Set Master Document
                  </button>
                </div>
                {/*<div className="acc-block nowrap">*/}
                {/*  <Field name="showContractFieldsInReceipt" component={FormCheckBoxField} onChecked={this.updateCheckBoxField}*/}
                {/*         labelEnabled="Show Contract Fields In Receipt" labelDisabled="Show Contract Fields In Receipt"*/}
                {/*         disabled={!formValues.enableFingerSignature} doubleMargin={true}*/}
                {/*  />*/}
                {/*</div>*/}
              </div>
            )}
          </div>
        </div>
      </ExpandSection>
    )
  }

}

const mapStateToProps = (store) => {
  const {accountPageInfo, sectionsOpened} = store.accountState;
  return {
    accountPageInfo,
    sectionsOpened,
    AR: AccessRights.get(store),
    formValues: (store.form && store.form.newEntity && store.form.newEntity.values) || {},
    docuSignPopupState: store.popups.docuSignPopupState
  };
};

const mapDispatchToProps = {
  toggleSectionOpened,
  setDocuSignPopupState,
  setFingerSignaturePopupState
};

export default connect(mapStateToProps, mapDispatchToProps)(DocusignAndFingerSignature);

